"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTableDateCell = void 0;
var common_constants_1 = require("../../../../common/constants/common-constants");
var bc_data_table_constants_1 = require("../bc-data-table-constants");
var DateFormatter = (function () {
    function DateFormatter() {
    }
    DateFormatter.format = function (_date, format) {
        var date = _date instanceof Date ? _date : new Date(_date);
        var DATE_PAD = 2;
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(DATE_PAD, '0');
        var day = String(date.getDate()).padStart(DATE_PAD, '0');
        return format.replace('YYYY', year.toString()).replace('MM', month).replace('DD', day);
    };
    return DateFormatter;
}());
var BcDataTableDateCell = (function () {
    function BcDataTableDateCell() {
    }
    BcDataTableDateCell.prototype.render = function (cell) {
        var newCell = document.createElement(common_constants_1.BcCommonConstants.TD_TAG);
        if (cell.class) {
            newCell.classList.add(cell.class);
        }
        var dateValue = DateFormatter.format(cell.value, bc_data_table_constants_1.BcDataTableConstansts.CELL_DATE_DEFAULT_FORMAT);
        if (cell.date_format) {
            dateValue = DateFormatter.format(cell.value, cell.date_format);
        }
        newCell.textContent = dateValue;
        return newCell;
    };
    return BcDataTableDateCell;
}());
exports.BcDataTableDateCell = BcDataTableDateCell;
